import { env } from "configs/EnvironmentConfig";
import { getHomeLink } from "constants/actionAccess";
import { errorMessage } from "helpers/utils";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { genJwtFromAzureFail, removeUserInfo } from "store/actions";
import { postSocialLogin } from "../../../helpers/fakebackend_helper";
//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import authService from "../../../services/authenService";
import { apiError, genJwtFromAzureSuccess, loginSuccess } from "./actions";
import { LOGIN_SUCCESS, GEN_JWT_FROM_AZURE_SUCCESS } from "./actionTypes";
import auditLogsService, {
  AUDIT_TRACKING_TOKEN_KEY,
} from "services/auditLogsService";
// Login Redux States
import {
  AUTH_TOKEN,
  FORCE_CHANGE_PASS,
  GEN_JWT_FROM_AZURE,
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  USER_INFO,
} from "./actionTypes";
// const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, navigate, tokenReCaptcha } }) {
  try {
    const response = yield call(authService.loginUser, {
      username: user.email,
      password: user.password,
      rememberMe: user.remember_me || false,
      // tokenReCaptcha: tokenReCaptcha || null,
    });
    localStorage.setItem(AUTH_TOKEN, response.id_token);
    // const responseResiterApp = yield call(authService.getRegisteredApp);
    const responseFinalAuth = yield call(authService.getFinalAuth, {
      appCode: env.APP_CODE,
    });
    if (responseFinalAuth) {
      localStorage.setItem(AUTH_TOKEN, responseFinalAuth.id_token);
      localStorage.setItem(USER_INFO, JSON.stringify({ userName: user.email }));
      // Force-change-password
      if (response?.password_policy?.force_change) {
        navigate("/change-password");
        localStorage.setItem(FORCE_CHANGE_PASS, "true");
      } else {
        navigate(getHomeLink());
      }

      yield put(loginSuccess());
    } else {
      localStorage.removeItem(AUTH_TOKEN);
      yield put(apiError({ message: "Can not get auth token !" }));
    }
  } catch (error) {
    localStorage.removeItem(AUTH_TOKEN);
    yield put(apiError(errorMessage(error)));
  }
}

function* logoutUser({ payload: { history, isAzure } }) {
  try {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(USER_INFO);
    localStorage.removeItem(FORCE_CHANGE_PASS);
    yield put(removeUserInfo());
    if (!isAzure) {
      window.location.href = "/login";
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      localStorage.setItem(AUTH_TOKEN, JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem(AUTH_TOKEN, JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* generateTokenAzure({ token, idToken, navigate }) {
  try {
    const response = yield call(authService.generateTokenAzure, {
      token,
      tenantCode: env.TENANT_CODE,
      appCode: env.APP_CODE,
      idToken,
      genTokenWithoutUser: false,
    });
    if (response && response.id_token) {
      localStorage.setItem(AUTH_TOKEN, response.id_token);
      // const info = jwt_decode(response.id_token);
      //
      const responseFinalAuth = yield call(authService.getFinalAuth, {
        appCode: env.APP_CODE,
      });
      if (responseFinalAuth) {
        localStorage.setItem(AUTH_TOKEN, responseFinalAuth.id_token);
        navigate(getHomeLink());
        yield put(genJwtFromAzureSuccess());
      } else {
        localStorage.removeItem(AUTH_TOKEN);
        yield put(
          genJwtFromAzureFail(
            "Tài khoản SSO không hợp lệ. Vui lòng liên hệ admin"
          )
        );
      }
      // //
      // const listRole = info["auth"].split(",");
      // if (
      //   listRole.length === 0 ||
      //   (listRole.length === 1 &&
      //     listRole.findIndex(role => role === "ROLE_ECONTRACT_FEC_EMPLOYEE") !==
      //       -1)
      // ) {
      //   yield put(
      //     genJwtFromAzureFail(
      //       "Tài khoản SSO không hợp lệ. Vui lòng liên hệ admin"
      //     )
      //   );
      // } else {
      //   localStorage.setItem(AUTH_TOKEN, response.id_token);
      //   navigate("/dashboard");
      //   yield put(genJwtFromAzureSuccess());
      // }
    } else {
      localStorage.removeItem(AUTH_TOKEN);
      yield put(
        genJwtFromAzureFail(
          "Tài khoản SSO không hợp lệ. Vui lòng liên hệ admin"
        )
      );
    }
  } catch (error) {
    yield put(
      genJwtFromAzureFail("Tài khoản SSO không hợp lệ. Vui lòng liên hệ admin")
    );
  }
}
function* fetchAuditTokenAfterLogin() {
  try {
    const res = yield call(auditLogsService.getAuditToken);
    const idToken = res?.data?.id_token ?? res?.id_token ?? null;
    if (idToken) {
      localStorage.setItem(AUDIT_TRACKING_TOKEN_KEY, idToken);
    }
  } catch (e) {}
}

function* authSaga() {
  yield all([
    takeEvery(LOGIN_SUCCESS, fetchAuditTokenAfterLogin),
    takeEvery(GEN_JWT_FROM_AZURE_SUCCESS, fetchAuditTokenAfterLogin),
  ]);
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(GEN_JWT_FROM_AZURE, generateTokenAzure);
}

export default authSaga;
